const REPO_NAME = "profiles";
const REPO_EMITENT = "invoiceIssuer";
import type { TBlueObj, TBlueTable } from "@app/types/insider";
import type { IProfile, TEmitent } from "@app/types/insider";
// import type { IGroupMember } from '@app/types/insider';
import type { TAccount, TDBAccount } from "@app/types/insider";

export const profiles: TBlueTable<IProfile> = {
  name: REPO_NAME,
  empty: {} as IProfile,
  initialState: {},
  primaryKey: "id",
  apiUrl: null,
  urlPathBuilder: null,
  mapWrite: null,
  mapRead: null,
  bootPriority: 0,
  starfx: false,
  starfx_index: "id",
  idb: false,
  idb_indexes: [],
  onmru: "no",
  oncsdb: "full",
  label: "Profil",
  appContext: ["CtxPersonalKarma", "CtxJurnalCorporate"],
};

export const invoiceIssuer: TBlueTable<TEmitent> = {
  name: "invoiceIssuer",
  empty: {} as TEmitent,
  initialState: {},
  primaryKey: "CIF",
  apiUrl: "/db/dbof_emitenti",
  urlPathBuilder: null, //  === epBuilderAnyIssuerNoSlices,
  mapWrite: null,
  mapRead: null,
  starfx: true,
  starfx_index: "CIF",
  idb: true,
  idb_indexes: [
    { name: "byABR", keyPath: "ABR" },
    { name: "byEID", keyPath: "E_ID" },
    { name: "byCIF", keyPath: "CIF" },
  ],
  bootPriority: 3, // set to  max // NO, IT WIIL BE LOADED ON DEMAND FIRST OF ALL
  onmru: "new",
  oncsdb: "full",
  label: "Emitenti",
  appContext: ["CtxPersonalKarma", "CtxJurnalCorporate"],
};
//I think this is a JGAP table
export const profileGroup: TBlueObj<any> = {
  name: "profileGroup",
  initialState: {
    GROUP_CREATED: null,
  },
  starfx: true,
  idb: false,
};

export const issuerBankAccounts: TBlueTable<TDBAccount> = {
  name: "issuerBankAccounts",
  empty: {} as TDBAccount,
  initialState: {},
  primaryKey: "CONTMA_ID",
  apiUrl: "/select/accounts",
  urlPathBuilder: null, //  === epBuilderAnyIssuerNoSlices,
  mapWrite: null,
  mapRead: null,
  starfx: true,
  starfx_index: "CONTMA_ID",
  idb: true,
  idb_indexes: [],
  bootPriority: 1,
  onmru: "no",
  oncsdb: "full",
  label: "Date financiare",
  appContext: ["CtxPersonalKarma", "CtxJurnalCorporate"],
};
